import { Ng2StateDeclaration } from "@uirouter/angular";
import { ReferenceAreaListComponent } from './components/reference-area-list/reference-area-list.component';

export const referenceAreasState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'reference-areas',
    url: '/project/:projectId/reference-areas',
    component: ReferenceAreaListComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const REFERENCE_AREAS_STATES = [
    referenceAreasState
];